module.exports = __webpack_public_path__ + "static/media/gasIcon.96b8776c.svg";